import React, { FC } from 'react';

import '../../css/CameraIcon.scss';

const CameraIcon: FC = (): JSX.Element => {
    return (
        <section className="camera-icon">
            <div className="lens"></div>
            <div className="infrared">
                <div className="flash1"></div>
            </div>
        </section>
    );
};

export default CameraIcon;
